import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const classicSoftwareTimelineEmbedRoute: InvariantJiraRoute = {
	name: 'classic-software-timeline-embed',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/timeline/embed',
};
